export const isAuthenticated = (state) => {
    console.log(state ,"state")
    if (state.auth.auth.idToken) return true;
    return false;
};
